import 'bootstrap/dist/js/bootstrap.js';
import 'angular';
import 'angular-aria';
import 'angular-animate';
import 'angular-bind-html-compile';
import 'angular-cookies';
import 'angular-credit-cards';
import 'angular-dynamic-locale';
import 'angular-local-storage';
import 'angular-messages';
import 'angular-recaptcha';
import 'angular-route';
import 'angular-sanitize';
import 'angular-scroll';
import 'slick-carousel';
import 'angular-slick-carousel'; //depends on slick-carousel
import 'angular-translate';
import 'angular-translate-loader-partial';
import 'angular-translate-loader-static-files';
import 'angular-ui-bootstrap';
import 'angular-utf8-base64';
import 'angularjs-slider';
import 'bootstrap-tabdrop/build/js/bootstrap-tabdrop.min.js';
import humanizeDuration from 'humanize-duration';
window.humanizeDuration = humanizeDuration;
import 'jquery-placeholder';
import 'jquery.cookie';
import 'jquery.ioslist/dist/js/jquery.ioslist';
import 'jquery-ui/dist/jquery-ui';
import 'dayjs';
import 'ng-combo-date-picker';
import 'ng-device-detector';
import 'ng-infinite-scroll/build/ng-infinite-scroll';
import 'malihu-custom-scrollbar-plugin';
// import 'commercial-management--digital--web-components-design--library';
import 'ng-scrollbars'; //depends on malihu-scrollbar-plugin
import 'rx-angular';
import 'ui-select';
import 'oclazyload';

/** LIBRARIES */
import '../decorators';
import 'ib-web-commons';
import 'ib-menus';


/** APP */
import '../ib-MmB-templates';
import '../app/core';
import '../ib-MmB-app';
import '../ib-MmB-constants';
import '../components/decorators';
import '../ib-MmB-app-config';
import '../components/filters';
import '../components/utils';
import '../components/ib-MmB-booking-management';
import '../components/ib-MmB-communication-lost';
import '../components/ib-MmB-flexibilization';
// import '../components/ib-MmB-flight-confirmation';
// import '../components/ib-MmB-health-form';
// import '../components/ib-MmB-on-hold-anulation';
// import '../components/ib-MmB-on-hold-confirmation';
// import '../components/ib-MmB-passengers-info';
import '../components/ib-MmB-search';
import '../components/ib-reusable-components';
import '../components/routing';
import '../components/services';
import '../components/transformers';
import '../components/ib-MmB-gastronomic-proposal';
import '../components/ib-MmB-voluntary-refunds';
// import '../components/ib-MmB-ancillaries-page';
import '../components/ib-MmB-payment';
import '../components/ib-Mmb-confirmation';
